import { useState } from "react";
import { FaEdit, FaRegEdit, FaTrash } from "react-icons/fa";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import {
  isAfterTime,
  timeBetween,
  timeBetweenHrs,
  timeBetweenMins,
} from "../../utils/dateUtil";

function WalletItem(props) {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [item, setItem] = useState(props.item);
  const [itemStatus, setitemStatus] = useState(item.status);
  const editItem = () => {
    navigate("/b2ba", { state: { item: item } });
  };

  const logPage = () => {
    // dispatch(updateFormInfo({ displayForm: false, formData: { product } }));
    navigate("/wlog", {
      state: {
        id: item.id,
        userId: item.user_id,
      },
    });
  };
  return (
    <>
      <tr>
        <td> {item.id} </td>
        <td className="align-middle">{item.name}</td>
        <td className="align-middle">{item.phone}</td>

        <td className="align-middle">{item.available_total}</td>
        {/* <td> {item.tout_location} </td> */}
        <td
          onClick={() => {
            logPage();
          }}
        >
          <Link>{item.logCount} Entries</Link>
        </td>
      </tr>
    </>
  );
}

export default WalletItem;
